<i-title
  [text]="(currentValve ? currentValve.title || 'valves.visualize' : 'valves.add') | translate"
  [hasBackIcon]="true"
  [buttons]="buttonsTitle"
  (iconClick)="back()"
></i-title>

<input
  type="file"
  [hidden]="true"
  [accept]="'.pdf,application/pdf'"
  id="uploader"
  (change)="selectFile($event)"
/>

<div dropzone="true" draggable="false" class="valve-detail" [ngClass]="dragAreaClass" *ngIf="form">
  <div class="valve-detail__left">
    @if(!currentValve || currentValve.statusId === 1 || currentValve.statusId === 3) {
      @if(!readonly) {
        <div class="valve-detail__title valve-detail__title--first">
          {{ "valves.file-title" | translate }} *<br />
          <span *ngIf="!currentFile">{{ "valves.file-limit" | translate }}</span>
        </div>
  
        @if (currentFileInfo) {
          <i-file [file]="currentFileInfo" [menuItems]="fileMenuItem"></i-file>
        } @else {
          <div class="valve-detail__add-file">
          <i-button
            [text]="'valves.add-file' | translate"
            [icon]="'bi bi-plus-circle-fill'"
            [styleClass]="'blue'"
            (click)="openUploadWindow()"
          ></i-button>
  
          <div class="d-flex align-items-center">
            <i class="bi bi-exclamation-circle-fill"></i>
  
            <span class="valve-detail__subtitle">{{
              "valves.info-drag-drop" | translate
            }}</span>
          </div>
          </div>
        } 
      }
    } @else if (currentValve.statusId === 2 || currentValve.statusId === 4) {
      <div class="valve-detail__publish">
        <div class="valve-detail__publish__title">
          {{ "valves.publication" | translate }}
        </div>

        <div class="valve-detail__publish__right">
          <i class="bi bi-check-circle-fill"></i>
          <span>{{
            "valves.publication-time"
              | translate : { date: currentValve.datePublication | date:"dd/MM/YYYY" , hours: currentValve.datePublication | date:"H:mm" }
          }}</span>
        </div>
      </div>

      @if (currentValve.statusId === 4) {
        <div class="valve-detail__publish mt-2">
          <div class="valve-detail__publish__title">
            {{ "valves.archive" | translate }}
          </div>
  
          <div class="valve-detail__publish__right">
            <i class="bi bi-archive-fill"></i>
            <span>{{
              "valves.archive-time"
                | translate : { date: currentValve.dateArchive | date:"dd/MM/YYYY" , hours: currentValve.dateArchive | date:"H:mm" }
            }}</span>
          </div>
        </div>
      }
    }

    <div class="valve-detail__title">{{ "valves.info-title" | translate }}</div>

    <div class="valve-detail__form">
      <div class="valve-detail__field">
        <label>
          <span>{{ "valves.form.object" | translate }} *</span>
        </label>

        <textarea 
          rows="3"
          pInputTextarea 
          [formControl]="getControl('title')"
          [placeholder]="'valves.form.object-placeholder' | translate">
        </textarea>
      </div>

      <div class="valve-detail__field valve-detail__field--flex-between">
        <div>
          <label>
            <span>{{ "valves.form.type" | translate }} *</span>
          </label>

          <p-dropdown [options]="typeOptions" [optionLabel]="'key'" [optionValue]="'value'" [formControl]="getControl('typeId')"></p-dropdown>
        </div>

        <div>
          <label>
            <span>{{ "valves.form.exp-date" | translate }}</span>
          </label>

          <i-input
            [type]="'calendar'"
            [iInput]="{ placeholder: 'JJ/MM/YYYY', options: {dateFormat: 'dd/mm/yy'} }"
            [control]="getControl('expirationDate')"
          ></i-input>
        </div>
      </div>

      <div class="valve-detail__field">
        <label>
          <span>{{ "valves.form.source" | translate }} *</span>
        </label>

        <p-dropdown [options]="sourceOptions" [optionLabel]="'key'" [optionValue]="'value'" [formControl]="getControl('sourceId')"></p-dropdown>
      </div>

      <div class="valve-detail__field">
        <label>
          <span>{{ "valves.form.nature" | translate }}</span> *
        </label>

        <p-dropdown [options]="natureOptions" [optionLabel]="'key'" [optionValue]="'value'" [formControl]="getControl('natureId')" (onChange)="getSubNature($event)"></p-dropdown>
      </div>

      @if (natureDescriptionOptions && natureDescriptionOptions.length > 0) {
        <div class="w-100 d-flex justify-content-center my-2">
          <i class="bi bi-arrow-down"></i>
        </div>
  
        <div class="valve-detail__field">
          <label *ngIf="natureDescriptionOptions.length === 1">
            <span>{{ natureDescriptionOptions[0].key }} *</span>
          </label>
  
          <p-dropdown *ngIf="natureDescriptionOptions.length > 1" [options]="natureDescriptionOptions" [optionLabel]="'key'" [optionValue]="'value'" [formControl]="getControl('descriptionId')"></p-dropdown>

          <i-input
            [type]="'calendar'"
            [iInput]="{ placeholder: 'JJ/MM/YYYY', options: {dateFormat: 'dd/mm/yy'} }"
            [control]="getControl('dateDescription')"
          ></i-input>
        </div>
      }

      <div class="valve-detail__required" *ngIf="!readonly || !currentValveId">
        * {{ 'global.required-field' | translate }}
      </div>

      @if (currentValve && currentValve.urlTokenTxt && (currentValve.statusId === 2 || currentValve.statusId === 4)) {
        <div class="valve-detail__stamp" (click)="openStampModal()">
          <svg width="260" height="181" viewBox="0 0 260 181" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="260" height="181" fill="white" />
            <circle cx="129.809" cy="91" r="74" stroke="#DC0B0B" stroke-width="4" />
            <circle cx="130.309" cy="90.5" r="58.5" stroke="#DC0B0B" stroke-width="4" />
            <rect x="13.2288" y="85.164" width="230" height="40" transform="rotate(-7 13.2288 85.164)" fill="white" stroke="#DC0B0B" stroke-width="4" />
            <text x="29" y="105" fill="#DE1A1A" dominant-baseline="central" transform="rotate(-7 13.2288 85.164)" font-weight="bold" font-size="24">
              {{ 'global.stamped' | translate }}
            </text>
          </svg>
        </div>
      }
    </div>
  </div>

  <div class="valve-detail__right">
    @if (!loadFile) {
      @if (currentFileInfo) {
        <i-viewer
          [allowExcelMode]="false"
          [viewerConfig]="viewerConfig"
          [file]="{
            extension: currentFileInfo.extension,
            title: currentFileInfo.name || '',
            src: currentFileInfo.src || ''
          }"
        >
        </i-viewer>
      }
      @else {
        <div class="valve-detail__no-file">
          <i class="bi bi-file-earmark-x-fill"></i>
          <span>{{ "global.no-file" | translate }}</span>
        </div>
      }
    } @else {
      <div class="w-100 d-flex justify-content-center">
        <i-loader></i-loader>
      </div>
    }
  </div>
</div>

<p-confirmDialog />
<app-confirmation-dialog></app-confirmation-dialog>

<i-modal [visible]="showStampModal" [header]="{title: 'valves.stamp-modal.title' | translate, closable: true}" (emitterOnVisibleChange)="showStampModal = $event">
  {{ currentValve ? currentValve.log : '' }}
</i-modal>
